function Soglashenie() {
  return (
    <div className="container">
      <div className="textBlockPage">
        <h2>Условия соглашения</h2>
        <p>
          Настоящим я, во исполнение требований Федерального закона от
          27.07.2006 г. No 152-ФЗ «О персональных данных» (с изменениями и
          дополнениями) свободно, своей волей и своем интересе, а также
          подтверждая свою дееспособность, даю свое согласие ООО «АЙТИ ГУРУ»
          (ИНН 7751196430), место нахождения: 108802, г. Москва, вн.тер.г.
          поселение Сосенское, д. Сосенки, ул. Ясеневая, д. 3, эт/пом/ком 1/1/11
          (далее – Компания), сайт Компании: https://aitiguru.ru на обработку
          своих персональных данных со следующими условиям: 
        </p>
        <ul className="textList3">
          <li>
            1. Данное Согласие дается на обработку персональных данных, как без
            использования средств автоматизации, так и с их использованием.
            Согласие дается на обработку следующих моих персональных данных:
            фамилия, имя, отчество; электронная почта; телефон; пользовательские
            данные (сведения о местоположении, тип и версия ОС, тип и версия
            Браузера, тип устройства и разрешение его экрана; источник, откуда
            пришел на сайт пользователь; с какого сайта или по какой рекламе;
            язык ОС и Браузера; какие страницы открывает и на какие кнопки
            нажимает пользователь; ip-адрес); данные обо мне, которые станут
            известны в ходе исполнения договоров (в случае заключения договора
            между мной и Компанией), а также иная общедоступная информация обо
            мне.
          </li>
          <li>2. Персональные данные не являются общедоступными.</li>
          <li>
            3. Цель обработки персональных данных: обработка входящих запросов
            физических лиц с целью оказания консультирования по различным
            вопросам, относящимся к сфере предпринимательской деятельности
            Компании; аналитики действий физического лица на веб-сайте и
            функционирования веб-сайта.
          </li>
          <li>
            4. Основанием для обработки персональных данных является статья 24
            Конституции Российской Федерации; статья 6 Федерального закона No
            152-ФЗ «О персональных данных»; настоящее Согласие посетителя сайта
            на обработку персональных данных.
          </li>
          <li>
            5. В ходе обработки с персональными данными будут совершены
            следующие действия: сбор, запись, систематизация, накопление,
            хранение, уточнение (обновление, изменение), извлечение,
            использование, передача (распространение, предоставление, доступ),
            блокирование, удаление, уничтожение.
          </li>
          <li>
            6. Настоящим я уведомлен Компанией, что предполагаемыми
            пользователями персональных данных являются работники Компании, а
            также лица, привлеченные Компанией на условиях гражданско-правового
            договора.
          </li>
          <li>
            7. Я ознакомлен (а), что:
            <ul className="textList2">
              <li>
                7.1. настоящее Согласие на обработку моих персональных данных
                является бессрочным и может быть отозвано посредством
                направления мною в адрес Компании (108802, г. Москва, вн.тер.г.
                поселение Сосенское, д. Сосенки, ул. Ясеневая, д. 3, эт/пом/ком
                1/1/11) письменного заявления. Датой отзыва считается день,
                следующий за днем вручения Компании письменного заявления об
                отзыве Согласия пользователя сайта на обработку персональных
                данных;
              </li>
              <li>
                7.2. имею право на доступ к моим персональным данным, требовать
                уточнения (обновление, изменение) моих персональных данных, а
                также удаления и уничтожения моих персональных данных в случае
                их обработки Обществом, нарушающих мои законные права и
                интересы, законодательство Российской Федерации.
              </li>
              <li>
                7.3. в случае отзыва Согласия на обработку персональных данных
                Общество вправе продолжить обработку персональных данных без
                моего согласия при наличии оснований, указанных в пунктах 2.11
                части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11
                Федерального закона No152-ФЗ «О персональных данных» от
                27.07.2006 г.
              </li>
            </ul>
          </li>
          <li>
            8. Я обязуюсь в случае изменения моих персональных данных, сведений
            обо мне незамедлительно сообщить Обществу, с предоставлением
            подтверждающих документов.
          </li>
          <li>
            9. Настоящим Согласием я подтверждаю, что являюсь субъектом
            предоставляемых персональных данных, а также подтверждаю
            достоверность предоставляемых данных.
          </li>
          <li>
            10. Настоящее Согласие действует все время до момента прекращения
            обработки персональных данных, согласно п. 7.1 Согласия.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Soglashenie;
